var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoffeeCup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    transform: "",
    id: "injected-svg",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.97 2.76A.995.995 0 0 0 17 2H7c-.46 0-.86.31-.97.76L5.22 6H4v2h1.07L6 21.07c.04.52.47.93 1 .93h10c.52 0 .96-.41 1-.93L18.93 8H20V6h-1.22zM16.71 11H7.29l-.21-3h9.85l-.21 3ZM7.78 4h8.44l.5 2H7.28zm.15 16-.21-3h8.57l-.21 3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeeCup);
export default __webpack_public_path__ + "static/media/coffee-cup.24bc7d101a2cfd03492ea26967fa87c3.svg";
export { ForwardRef as ReactComponent };